module.exports = __webpack_public_path__ + "static/media/daemon-skull.ec5b5916.svg";